<template>
  <!--begin::App-->
  <div
    :class="{
      'unlogged-page': isUnloggedPage,
    }"
    class="d-flex flex-column flex-root app-root"
    id="kt_app_root">
      <!--begin::Page-->
      <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
        <!-- HEADER -->
        <TheHeader /><!-- END HEADER -->
        <!--begin::Wrapper-->
        <div
          class="d-flex flex-column flex-row-fluid"
          :class="{
            'app-wrapper': authenticated
          }"
          id="kt_app_wrapper"
        >
          <!--begin::Sidebar-->
          <TheSidebar v-if="authenticated" />
          <!--end::Sidebar-->

          <!-- Impersonate -->
          <div
            class="font-size-xSmall fw-bold bg-color1 text-center py-2 mb-1"
            v-if="isImpersonating"
          >
            <p class="mb-0">
              Impersonate habilitado.
              <a href="#" class="text-underline" @click.prevent="stopImpersonate">
                {{ $t('click_here') }}
              </a>
              para encerrar.
            </p>
          </div><!-- Impersonate -->

          <template v-if="user">
            <div
              class="font-size-xSmall fw-bold bg-color1 text-center py-2"
              v-if="user.notifications.instability"
            >
              <p class="mb-0">
                {{ $t('some_systems_may_be_unstable') }} <a href="mailto:falecom@pixelroads.com.br">falecom@pixelroads.com.br</a>
              </p>
            </div>
          </template>

          <!--begin::Main-->
          <main class="app-main flex-column flex-row-fluid" id="kt_app_main">
            <!--begin::Content wrapper-->
            <div class="d-flex flex-column flex-column-fluid">
              <!--begin::Toolbar-->
              <div id="kt_app_toolbar" class="app-toolbar mb-10">
                <!--begin::Toolbar container-->
                <div id="kt_app_toolbar_container" class="container-fluid d-flex flex-stack px-0">
                  <slot name="toolbar"></slot>
                </div>
                <!--end::Toolbar container-->
              </div>
              <!--end::Toolbar-->

              <!--begin::Content-->
              <div id="kt_app_content" class="app-content flex-column-fluid">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container">
                  <slot></slot>
                </div>
                <!--end::Content container-->
              </div>
              <!--end::Content-->
            </div>
            <!--end::Content wrapper-->
            <!--begin::Footer-->
            <TheFooter v-if="authenticated || $route.name == 'statics.terms' || $route.name == 'orders.payment.create'"/>
          </main>
          <!--end:::Main-->
        </div>
        <!--end::Wrapper-->
      </div>
      <!--end::Page-->
  </div>
  <!--end::App-->
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import { mapState, mapActions } from 'vuex'

import TheHeader from '@/components/headers/TheHeader'
import TheFooter from '@/components/footers/TheFooter2'
import TheSidebar from '@/components/sidebars/TheSidebar'

export default {
  name: 'MainLayout',
  components: {
    TheHeader,
    TheSidebar,
    TheFooter
  },
  mounted () {
    this.$router.afterEach(() => {
      setTimeout(() => {
        if (window.KTDrawer && typeof window.KTDrawer.createInstances === 'function') {
          window.KTDrawer.createInstances()
        }
      }, 100)
    })
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated,
      isImpersonating: state => state.isImpersonating
    }),
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      errors: state => state.errors,
      notification: state => state.notification
    }),
    currentYear () {
      return new Date().getFullYear()
    },
    isUnloggedPage () {
      const route = this.$route.name
      if (
        route === 'password.create' ||
        route === 'password.reset' ||
        (route === 'home' && !this.authenticated)
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions(['clearErrors']),
    clearGlobalErrors () {
      this.clearErrors()
    },
    async stopImpersonate () {
      await AuthService.stopImpersonate()
      window.location.href = '/'
    }
  }
}
</script>

<style lang="scss" scoped>

main {
  background-color: #f6f6f6;
  & > .container {
    max-width: 1100px;
  }
}

</style>
